import { Component } from '@angular/core';

@Component({
  selector: 'app-hyper-id',
  templateUrl: './hyper-id.component.html',
  styleUrls: ['./hyper-id.component.scss']
})
export class HyperIdComponent {

}
